import { fetchJobItemsByJobId } from "../../utils/apiUtils"
import ReactJson from "react-json-view";
import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import {
    fetchBenefitPlanTableScan, fetchHrpTableItemsByHccID, fetchBenefitPlanTableItemsByPk, fetchHrpTableItemsBySk, fetchHrpTableItemsBySparse, fetchHrpTableScan, fetchItemsByRetryOn, fetchNotificationsJobRegistryTableItemsByPk,
    fetchNotificationsJobRegistryTableScan,
    fetchJobs
} from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";
import { queryClient } from "../../App";
import DatePicker from "react-datepicker";
import ToggleSwitch from "../shared/ToggleSwitch";
import { getTimeDiff } from "../../utils/commonUtils";
import Select from 'react-select';

// const searchOptions = [
//     { value: 'JobId', label: 'JobId', additional: { pkKey: 'pk', skKey: 'sk' } },
//     { value: 'invertedIndex', label: 'invertedIndex', additional: { pkKey: 'sk', skKey: 'pk' } },
//     { value: 'sparseIndex', label: 'sparseIndex', additional: { pkKey: 'sparse', skKey: 'pk' } }
// ]

const JobDetails = ({ job, autoRefreshEnabled: parentAutoRefreshEnabled }) => {

    const now = new Date()

    const timezoneOffsetMs = now.getTimezoneOffset() * 60000;
    const localStartOfDayNow = new Date(now.getTime() - timezoneOffsetMs);
    localStartOfDayNow.setHours(0, 0, 0, 0);
    const [showMoreColumns, setShowMoreColumns] = useState(false);


    const [selectedSearchOption, setSelectedSearchOption] = useState(null);
    const [searchPkValue, setSearchPkValue] = useState();
    const [decouncedSearchPkValue, setDecouncedSearchPkValue] = useState();

    const [searchSkValue, setSearchSkValue] = useState();
    const [decouncedSearchSkValue, setDecouncedSearchSkValue] = useState();

    const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(parentAutoRefreshEnabled)

    const [selectedDate, setSelectedDate] = useState();

    useEffect(() => {
        setAutoRefreshEnabled(parentAutoRefreshEnabled)

    }, [parentAutoRefreshEnabled])

    // useEffect(() => {
    //     if (subscriptionHccId) {
    //         setSelectedSearchOption({ value: 'hccId', label: 'hccId' })
    //         setSearchPkValue(subscriptionHccId)
    //         setDecouncedSearchPkValue(subscriptionHccId)
    //     }

    // }, [subscriptionHccId])

    const { ref, inView } = useInView();

    const queryKey = ['job-registry-job-items', job?.pk, job?.sk, selectedDate, selectedSearchOption?.value, decouncedSearchPkValue, decouncedSearchSkValue];

    const {
        data,
        refetch,
        fetchNextPage,
        fetchPreviousPage,
        isLoading, //first time only
        isFetching,
        hasNextPage,
        isFetched,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isError,
        status,
        error
    } = useInfiniteQuery({
        retry: false,
        refetchInterval: autoRefreshEnabled ? 1000 * 3 : false,
        refetchOnWindowFocus: true,
        queryKey,
        queryFn: ({ pageParam }) => {
            let params = {
                jobPk: job.pk,
                jobSk: job.sk,
                lastEvaluatedKey: pageParam
            };

            return fetchJobItemsByJobId(params)
        },
        select: (data) => {
            return {
                pages: data.pages.map((page) => page.Items?.map(item => {
                    //TODO custom manipulaton
                    return item
                })).flatMap((x) => x),
                pageParams: data.pageParams,
            };
            // return { ...data.hits, timestamp: Date.now() }
        },
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.LastEvaluatedKey ? encodeURIComponent(JSON.stringify(lastPage.LastEvaluatedKey)) : null
        },
        staleTime: 0,//,Infinity,
        enabled: !!job  //&& !!showChat
    })

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchPkValue(event.target.value?.trim());
        }, 500),
        []
    );

    // const debouncedSkChangeHandler = useCallback(
    //     debounce((event) => {
    //         setDecouncedSearchSkValue(event.target.value?.trim());
    //     }, 500),
    //     []
    // );


    // const resutls = data?.pages.flat()
    const items = data?.pages.flat();

    let columns = ['pk', 'sk', 'status', 'errorMessage', 'note'];

    if (showMoreColumns) {
        columns = [
            'pk', 'sk',
            ...columns,
            'createdAt',

        ];
    }

    const today = new Date();
    // today.setDate(today.getDate() + 1);

    return (
        <div className="container">

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                    <p className="title">{job?.jobName} </p>
                    {/* <p className="sub-title">Search hints:   </p> */}


                </div>
                <div>
                    <ToggleSwitch
                        label={`Auto Refresh`}
                        onToggle={(val) => setAutoRefreshEnabled(val)}
                        initialState={autoRefreshEnabled}
                    />
                </div>

            </div>





            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1rem 1rem 1rem 0rem", }}>
                {/* <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {

                        setSelectedSearchOption(null)
                        setSearchPkValue('');
                        setDecouncedSearchPkValue('');
                        setSearchSkValue('');
                        setDecouncedSearchSkValue('')
                    }}
                >
                    Clear filters
                </p> */}
                <p></p>
                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>
            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"job-registry-items"}
                        columns={columns}
                        items={items}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}


        </div>
    )
}

export default JobDetails